module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/online-report-5.6c6aad06.svg";